const getBarColor = (value) => {
  if (value >= 95) return "#009F52";
  if (value >= 90) return "#FFC100";
  return "#FB0301";
};

const LEGEND = [
  { color: "#FB0301", label: "< 90%" },
  { color: "#FFC100", label: "90% – 95%" },
  { color: "#009F52", label: "≥ 95%" },
];

export default function ProgressBarChartResponse({ data }) {
  if (!data?.items) return null;
  const { items, show_legend, value_suffix = "%" } = data;

  return (
    <div className="flex flex-col gap-3 mt-2 w-full">
      {show_legend && (
        <div className="flex gap-4 flex-wrap mb-1">
          {LEGEND.map((l, i) => (
            <div key={i} className="flex items-center gap-1.5 text-xs text-gray-500">
              <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: l.color }} />
              {l.label}
            </div>
          ))}
        </div>
      )}
      {items.map((item, i) => {
        const label = item.label || item.name;
        const color = getBarColor(item.value);
        return (
          <div key={i} className="flex items-center gap-3">
            <span className="font-mono text-[12px] text-gray-500 w-48 min-w-[140px] truncate" title={label}>
              {label}
            </span>
            <div className="flex-1 h-2.5 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{ width: `${item.value}%`, background: color }}
              />
            </div>
            <span className="text-[12px] font-semibold w-8 text-right" style={{ color }}>
              {item.value}{value_suffix}
            </span>
          </div>
        );
      })}
    </div>
  );
}